var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCourse = function SvgCourse(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    fill: "none",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DC2626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.75 3.981c0-.063.015-.126.044-.184.066-.13.259-.224.644-.415l4.043-1.994c.708-.35 1.062-.524 1.436-.592.33-.061.67-.061 1 0 .373.068.727.243 1.435.592l4.043 1.994c.386.19.579.286.644.415.057.112.06.242.006.356-.06.13-.25.232-.63.434L9.472 6.688c-.75.4-1.124.599-1.521.677-.352.069-.715.069-1.066 0-.398-.078-.772-.278-1.521-.677L1.418 4.587c-.38-.202-.569-.303-.63-.434A.407.407 0 0 1 .75 3.98Zm0 0V8.75m2-3.454v4.211c0 .226 0 .338.033.44.029.088.077.17.14.24.07.079.169.134.364.246l.425.243c1.35.771 2.026 1.157 2.743 1.308.634.134 1.29.134 1.924 0 .717-.15 1.392-.537 2.742-1.308l.425-.243c.196-.112.293-.168.365-.246a.666.666 0 0 0 .14-.24c.032-.102.032-.208.032-.433V5.296"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCourse);
export default ForwardRef;